import { grayPalette } from '../../../themes/colors';

export const secondarySidenavLightTheme = {
  backgroundColor: grayPalette[100],
};
